module.exports = __webpack_public_path__ + "img/edit.bbced313.svg";